<div class="sds-widget">
  <!-- Loading -->
  <div class="sds-widget-loading" *ngIf="loading">
    <i class="pi pi-spin pi-spinner"></i>
  </div>

  <!-- Empty -->
  <div class="sds-widget-empty" *ngIf="!loading && items.length === 0">
    <span translate>NO_RECORDS_FOUND</span>
  </div>

  <!-- List view (internal scroll area) -->
  <div
    class="sds-widget-list"
    *ngIf="!loading && items.length > 0 && view === 'list'"
    [class.expanded]="expanded"
  >
    <button
      type="button"
      class="sds-widget-row"
      *ngFor="let item of visibleItems"
      (click)="openDetail(item)"
      [title]="item.product"
    >
      <span class="sds-widget-risk-dot" [style.background-color]="item.riskColor"></span>

      <span class="sds-widget-name">{{ item.product }}</span>

      <span class="sds-widget-pictograms" *ngIf="item.pictograms.length">
        <img
          *ngFor="let p of visiblePictograms(item)"
          [src]="getPictogramInfo(p).svg"
          [alt]="getPictogramInfo(p).ghs"
          [title]="getPictogramInfo(p).ghs"
          class="sds-widget-pictogram-img"
        />
        <span
          *ngIf="hiddenPictogramCount(item) > 0"
          class="sds-widget-pictogram-more"
          [title]="hiddenPictogramNames(item)"
        >+{{ hiddenPictogramCount(item) }}</span>
      </span>
    </button>
  </div>

  <!-- Expand / collapse (list view only) -->
  <button
    type="button"
    class="sds-widget-toggle"
    *ngIf="!loading && hasMore && view === 'list'"
    (click)="toggleExpanded()"
  >
    <i class="pi" [ngClass]="expanded ? 'pi-minus' : 'pi-plus'"></i>
    <span>{{ (expanded ? 'SDS_WIDGET_SHOW_LESS' : 'SDS_WIDGET_SHOW_ALL') | translate }}</span>
  </button>

  <!-- Graph view — total count of records per risk level -->
  <div class="sds-widget-risk-summary" *ngIf="!loading && items.length > 0 && view === 'graph'">
    <button type="button" class="sds-widget-risk-row" (click)="openRiskList('low')">
      <span class="sds-widget-risk-label" translate>SDS_RISK_LOW</span>
      <span class="sds-widget-risk-track">
        <span class="sds-widget-risk-fill low" [style.width.%]="riskBarPercent(riskSummary.low)"></span>
      </span>
      <span class="sds-widget-risk-count">{{ riskSummary.low }}</span>
    </button>
    <button type="button" class="sds-widget-risk-row" (click)="openRiskList('medium')">
      <span class="sds-widget-risk-label" translate>SDS_RISK_MEDIUM</span>
      <span class="sds-widget-risk-track">
        <span class="sds-widget-risk-fill medium" [style.width.%]="riskBarPercent(riskSummary.medium)"></span>
      </span>
      <span class="sds-widget-risk-count">{{ riskSummary.medium }}</span>
    </button>
    <button type="button" class="sds-widget-risk-row" (click)="openRiskList('high')">
      <span class="sds-widget-risk-label" translate>SDS_RISK_HIGH</span>
      <span class="sds-widget-risk-track">
        <span class="sds-widget-risk-fill high" [style.width.%]="riskBarPercent(riskSummary.high)"></span>
      </span>
      <span class="sds-widget-risk-count">{{ riskSummary.high }}</span>
    </button>
  </div>
</div>
